// extracted by mini-css-extract-plugin
export default {"root":"GoalForm_root__QckCu","container":"GoalForm_container__i301U","btnBlock":"GoalForm_btnBlock__HtA+O","form":"GoalForm_form__vv0mX","formGroup":"GoalForm_formGroup__xjNQb"};